import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { first, skipWhile, Subscription } from 'rxjs';
import { onMoment } from '@app/shared/helpers/moment';
import { InventoryDialogComponent } from '../inventory-dialog/inventory-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { selectCountsState } from '../store/selectors/counts.selectors';
import { Store } from '@ngrx/store';
import * as CountsActions from '../store/actions/counts.actions';
import { FormControl, FormGroup } from '@angular/forms';
import { selectSettingsState } from '@app/modules/settings/store/selectors/settings.selectors';
import { SendMailModalComponent } from '@app/shared/components/send-mail-modal/send-mail-modal.component';

@Component({
  selector: 'app-reorder',
  templateUrl: './reorder.component.html',
  styleUrls: ['./reorder.component.scss']
})

export class ReorderComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  public inventory: any;
  public inventorySubscription: Subscription;
  public dataSource: MatTableDataSource<any>;
  public sortedData = [];
  public isLoading = true;
  public endTimeStamp: string;
  public prdMinQtyForm: FormGroup;
  public moq = 1;
  public columns = [
    { columnDef: 'prdCode', header: 'Product Code' },
    { columnDef: 'prdNameEn', header: 'Description' },
    { columnDef: 'prdCasePack', header: 'UOM' },
    { columnDef: 'invitmCount', header: 'Count' },
    { columnDef: 'pcmMinQty', header: 'MSL' },
    { columnDef: 'invOrder', header: 'Quantity to Order' },
    { columnDef: 'pcmDesc', header: 'Order By' },
  ];
  public subs = new SubSink;
  public displayedColumns = this.columns.map(c => c.columnDef);
  public isLoaded: boolean = false;
  public hasAsteriskProducts = false;
  public settings$;

  constructor(
    public _inventory: InventoryService,
    private _dialogRef: MatDialogRef<InventoryDialogComponent>,
    private _router: Router,
    private _matDialog: MatDialog,
    private store$: Store
  ) {
    let id;
    this.subs.add(this.store$.select(selectCountsState).subscribe(res => id = res.currentId));
    this.store$.dispatch(CountsActions.loadReorder({ invID: id, active: 'prdNameEn', direction: 'asc', pcmType: 1 }));
  }

  ngOnInit(): void {
    this.subs.add(this.store$.select(selectCountsState).pipe(skipWhile(({ currentInventory }) => currentInventory == null)).subscribe(({ currentInventory, isLoading }) => {
      
      const mergedItems = Object.values(
        currentInventory.invItems.reduce((acc, item) => {
          const prdID = item.prdID;
          const itemCount = parseFloat(item.invitmCount) || 0;

          if (!acc[prdID]) {
            acc[prdID] = {
              ...item,
              invitmCount: itemCount,
              isCombined: false,
              invOrder1: item.invOrder1,
              invOrder2: item.invOrder2
            };
          } else {
            acc[prdID].invitmCount += itemCount;
            acc[prdID].isCombined = true;

            const combinedCount = acc[prdID].invitmCount;
            acc[prdID].invOrder1 = combinedCount < acc[prdID].defaultOrderMinQty1 
              ? acc[prdID].defaultOrderMinQty1 - combinedCount 
              : 0;
            acc[prdID].invOrder2 = combinedCount < acc[prdID].defaultOrderMinQty2 
              ? acc[prdID].defaultOrderMinQty2 - combinedCount 
              : 0;

            this.hasAsteriskProducts = true;
          }
      
          return acc;
        }, {})
      );

      this.dataSource = new MatTableDataSource(mergedItems);
      this.inventory = currentInventory.inv;
      this.isLoading = isLoading;
    }));

    this.subs.add(this.store$.select(selectSettingsState).subscribe((settings) => {
      this.settings$ = settings;
      this.prdMinQtyForm = new FormGroup({ pcmType: new FormControl(1) });
    }));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onGeneratePDF() {
    this._inventory.onCreateReorderPDF(this.moq, this.sort.active ? this.sort.active : 'prdNameEn', this.sort.direction ? this.sort.direction : 'asc', this._inventory.isFinalizeScreen() ? 1 : 0);
  }

  parseInt(int) {
    if (!!int) {
      return int;
    }

    return 0;
  }

  onMomentEvent(time) {
    return onMoment(time);
  }

  getQty(min, count) {
    let total = min - count;
    return Math.round(Math.max(0, total));
  }

  onRound(element) {
    return Math.max(0, element);
  }

  public onNavigate(prdID) {
    this._dialogRef.close();
    this._router.navigate([`/products/${prdID}`]);
  }

  setMinQty(event) {
    this.moq = event.value;
  }

  public onSortData(sort: Sort) {
    this.store$.dispatch(CountsActions.loadReorder({ invID: this.inventory.invID, active: sort.active, direction: sort.direction, pcmType: this.moq }));
  }


  public compare(a: any | string, b: number | string, isAsc: boolean) {
    if (isAsc === true) {
      return a < b ? 1 : -1;
    } else {
      return a > b ? 1 : -1;
    }
  }

  public checkValue(v) {
    if (v > 0) {
      return true;
    }
    return false;
  }

  sendReport() {
    const dialog = this._matDialog.open(SendMailModalComponent, {
      minWidth: '30vw',
      maxWidth: '700px',
    });

    dialog.afterClosed().pipe(first()).subscribe(res => {
       if(res!=null && res.email!=null && res.email!=''){
          const data = {
            email: res.email,
            id: this.inventory.invID,
            active: this.sort.active ? this.sort.active : 'prdNameEn',
            direction: this.sort.direction ? this.sort.direction : 'asc',
            finalized: this._inventory.isFinalizeScreen() ? 1 : 0,
            pcm_type: this.moq,
            type: 'byReorder'
          }
          
          this._inventory.onSendReportPDF(data);
        }
    });
  }


}
